export enum DashboardJobType {
    published = 'published',
    drafts = 'draft',
    archived = 'archived',
}
